// ======================================================================
// File Name       : ContentLinkingDetailSettingRegisterEditContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { submit } from 'redux-form';
import ContentLinkingDetailSettingRegisterEditForm from '../../components/contentLink/ContentLinkingDetailSettingRegisterEditForm';
import ModalWrapper from '../../components/modal/ModalWrapper';
import { MODE } from '../../constants';
import { REDIRECT_MODAL } from '../../constants/ContentLinkConstants';
import * as modalIds from '../../constants/ModalIds';
import * as modalActions from '../../actions/ModalAction';
import * as itemActions from '../../actions/ItemAction';
import { PUBLIC_STATUS, END_CONDITION_TYPE_FOR_ITEM, CHOSEN_THUMBNAIL_CONTENT } from '../../constants/ItemConstant';
import * as actionType from '../../constants/actionTypes/page';

class ContentLinkingDetailSettingRegisterEditContainer extends Component {
  constructor() {
    super();
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getModalOptions = this.getModalOptions.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  getModalOptions() {
    return {
      title: 'コンテンツの情報を指定してください',
      footerBtns: null,
    };
  }

  handleSubmit(values) {
    const { dispatch } = this.props;
    let imageUploadFile = null;
    if (values && values.imageUploadFile && values.imageUploadFile[0]) {
      imageUploadFile = values.imageUploadFile[0];
      const reader = new FileReader();
      reader.readAsDataURL(imageUploadFile);
      reader.onload = () => {
        const dataUrl = reader.result;
        values.dataUrl = dataUrl;
        dispatch(itemActions.updateItem(values));
      };
    }
    dispatch(itemActions.updateItem(values));
    dispatch(modalActions.openModal(modalIds.CONTENT_LINKING_CONFIRM));
  }

  closeModal() {
    this.props.dispatch({
      type: actionType.CLEAR_SEARCH_CONDITION,
    });
    this.props.hideModal();
  }

  render() {
    return (
      <ModalWrapper {...this.getModalOptions()} hideModal={this.closeModal} dialogClassName="modal-width-950">
        <ContentLinkingDetailSettingRegisterEditForm
          onSubmit={this.handleSubmit}
          onBackBtnClick={() => {
            if (this.props.editMode === MODE.NEW_MODE) {
              this.props.dispatch(modalActions.openModal(modalIds.CONTENT_LINKING_REGISTER));
            } else {
              this.props.hideModal();
            }
          }}
        />
      </ModalWrapper>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({
  editMode: state.item.editMode,
});

export default connect(mapStateToProps)(ContentLinkingDetailSettingRegisterEditContainer);
